// extracted by mini-css-extract-plugin
export default {"component":"Locations-module__component-SZZa"};